import { Redirect, Route } from "react-router-dom"
import useAuthStore from "../store/authStore"
import ControlledNavigation from "./Components/ControlledNavigation.jsx"
import ErrorBoundary from "../Components/ErrorBoundary"

function ProtectedRoute({ component: Component, ...restOfProps }) {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  
    return (
      <Route
        {...restOfProps}
        render={(props) =>
          isAuthenticated ? (
            <ErrorBoundary>
              <ControlledNavigation component={Component} />
            </ErrorBoundary>
          ) : (
            <Redirect to="/admin/login" />
          )
        }
      />
    )
  }

export default ProtectedRoute
